export const FirebaseConfig = {
	"projectId": "slotin-townride",
	"appId": "1:150667586089:web:a9d0f6a1e8e089454cca38",
	"databaseURL": "https://slotin-townride-default-rtdb.firebaseio.com",
	"storageBucket": "slotin-townride.firebasestorage.app",
	"apiKey": "AIzaSyAUo9dj2tnSLB4X61Vta6B7jCbRxSxI1NI",
	"authDomain": "slotin-townride.firebaseapp.com",
	"messagingSenderId": "150667586089",
	"measurementId": "G-V1LYQHX8FQ",
	"projectNumber": "150667586089",
	"version": "2"
};